var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.hideTitle)?_c('h1',{staticClass:"primary--text"},[_vm._v("Privacy Policy")]):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.currentClient.privacyPolicy)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }